import { useCameraApiCredentials, useCameraApiUrl } from "@/hooks";
import { useState } from "react";
import { useUploadTaskImages } from "./useUploadTaskImages";

const getFilename = () => `image-${Date.now()}.jpeg`;

export const useCaptureImageFromCamera = () => {
  const cameraApiUrl = useCameraApiUrl();
  const credentials = useCameraApiCredentials();
  const { enqueueUploads, isUploading, pendingUploads } = useUploadTaskImages();
  const [isLoading, setIsLoading] = useState(false);

  const handleCaptureImage = async (mxid: string, streamName: string) => {
    setIsLoading(true);
    try {
      const url = `${cameraApiUrl}/cameras/${mxid}/streams/${streamName}/still`;
      // The relay authorizes by cookie and a raw fetch sends none by default;
      // a LAN camera rejects a credentialed request outright — hence the
      // resolved mode rather than a hardcoded "include".
      const response = await fetch(url, { credentials });
      if (!response.ok) throw new Error("Failed to capture image");
      const blob = await response.blob();

      await enqueueUploads([
        {
          blob,
          filename: getFilename(),
          contentType: "image/jpeg",
          capturedAt: new Date().toISOString(),
        },
      ]);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    handleCaptureImage,
    isLoading,
    isUploading,
    pendingUploads,
  };
};
